<h5>{{t 'r4b.modules.blockContent.logic.title'}}</h5>
<input type="text" class="logic form-control" placeholder="logic syntax here..." data-selection={{selectorId}} style="width:100%" value={{model.logic}}></input>
